import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterModule, Routes, RouterLink, RouterLinkActive } from '@angular/router';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';

import { ClickDirective } from './directives/click.directive';

import { NavComponent } from '@src/app/shared/nav/nav.component';
import { FooterComponent } from '@src/app/shared/footer/footer.component';
import { ContactFormComponent } from './contact-form/contact-form.component';
import { SocialComponent } from './social/social.component';
import { LogoContextMenuComponent } from './logo-context-menu/logo-context-menu.component';


@NgModule({
  declarations: [
		ClickDirective,
		NavComponent,
		FooterComponent,
		ContactFormComponent,
		SocialComponent,
		LogoContextMenuComponent
	],
	imports: [
		CommonModule, 
		FormsModule,
		ReactiveFormsModule,
		RouterLink,
		RouterLinkActive
	],
  exports: [
		RouterModule,
		RouterLink,
		RouterLinkActive,
		ClickDirective,
		NavComponent,
		FooterComponent,
		ContactFormComponent,
		SocialComponent,
		LogoContextMenuComponent
	]
})
export class SharedModule {}
